import { Component, ElementRef, ViewChild } from '@angular/core';
import { GiphyService } from 'src/app/services/giphy/giphy.service';

@Component({
  selector: 'app-giphy',
  templateUrl: './giphy.component.html',
  styleUrls: ['./giphy.component.scss'],
  standalone: false,
})
export class GiphyComponent {
  @ViewChild('inputSearch') inputSearchRef: ElementRef;

  gfData: any;
  giphySearchValue: string;
  isShowResetSearch: boolean;

  constructor(public giphyService: GiphyService) {
    this.gfData = [];
    this.giphySearchValue = '';
    this.isShowResetSearch = false;
  }

  getDataGiphy() {
    this.giphyService.fetch().then((resp) => {
      if (resp.meta.status === 200) {
        this.gfData = resp.data;
      }
    });
  }

  searchGiphy() {
    if (this.giphySearchValue !== '') {
      this.giphyService.search(this.giphySearchValue).then((resp) => {
        if (resp.meta.status === 200) {
          this.gfData = [];
          this.gfData = resp.data;
        }

        this.inputSearchRef.nativeElement.blur();
      });
    }
  }

  setGift(image) {
    this.giphyService.setImage(image);
  }

  resetSearch() {
    this.giphySearchValue = '';
    this.getDataGiphy();
  }

  ngOnInit() {
    this.getDataGiphy();
  }

  ngDoCheck() {
    if (this.giphySearchValue === '') {
      this.isShowResetSearch = false;
    } else {
      this.isShowResetSearch = true;
    }
  }

  ngAfterViewInit() {}
}
